/**
 * Route definition for /signup
 * Renders the SignUpContainer component.
 *
 * @module routes/signup
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import SignUpContainer from '@/containers/SignUp'
import { setPageMetadata } from '@/utils/page-metadata'

export const Route = createFileRoute('/$locale/signup')({
  component: SignUp,
})

function SignUp() {
  setPageMetadata({
    title: 'Sign Up | VIRI',
    description: 'Create a new account on VIRI NFT Marketplace.',
    ogImage: '',
    ogType: 'website',
    twitterCard: 'summary_large_image',
  })

  return (
    <>
      <SignUpContainer/>
    </>
  )
}